import { render, staticRenderFns } from "./PasswordOtp.vue?vue&type=template&id=39f67273&"
import script from "./PasswordOtp.vue?vue&type=script&lang=js&"
export * from "./PasswordOtp.vue?vue&type=script&lang=js&"
import style0 from "./PasswordOtp.vue?vue&type=style&index=0&id=39f67273&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f67273')) {
      api.createRecord('39f67273', component.options)
    } else {
      api.reload('39f67273', component.options)
    }
    module.hot.accept("./PasswordOtp.vue?vue&type=template&id=39f67273&", function () {
      api.rerender('39f67273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/PasswordOtp.vue"
export default component.exports